import { hotelProviderLabel } from '../hotels/hotelProvider';
import { PolicyRouteOption } from './policy';

/** Local display names never replace routing identity. */
export function providerLabel(route: PolicyRouteOption) {
  return [hotelProviderLabel(route.connector, route.access_display_name, route.access_code, '—'), route.display_name, route.access_code].filter(Boolean).join(' · ');
}
